import {AfterViewChecked, Directive, ElementRef, Input, OnChanges} from '@angular/core';

/** Reveal a linked card once it has been rendered, without stealing focus on refresh. */
@Directive({
    selector: '[appFocusedFile]',
    standalone: true,
    host: {
        '[class.focused-file]': 'appFocusedFile',
        '[attr.tabindex]': 'appFocusedFile ? -1 : null',
        '[attr.data-focused-file]': 'appFocusedFile ? "true" : null'
    }
})
export class FocusedFileDirective implements OnChanges, AfterViewChecked {
    @Input() appFocusedFile = false;
    private revealPending = false;

    constructor(private element: ElementRef<HTMLElement>) {}

    ngOnChanges(): void { this.revealPending = this.appFocusedFile; }

    ngAfterViewChecked(): void {
        if (!this.revealPending) return;
        this.revealPending = false;
        this.element.nativeElement.scrollIntoView({block: 'center', inline: 'nearest'});
        this.element.nativeElement.focus({preventScroll: true});
    }
}
